import { useQuery } from '@connectrpc/connect-query'

import { useAuthenticated } from '@jotta/auth-client/useAuthStatus'
import { getCustomer } from '@jotta/grpc-connect-openapi/customerQuery'
import { languageToLocale } from '@jotta/i18n'

import { createConnectQuery } from '../createConnectQuery'
import { authTransport } from '../transport'
import { useCustomerSubscription } from '../useSubscription'

export const getCustomerQuery = createConnectQuery(getCustomer)
export const getCustomerQueryKey = getCustomerQuery.getKey({})

export function useGetCustomer() {
  const authenticated = useAuthenticated() === 'TRUE'
  useCustomerSubscription(() => getCustomerQuery.invalidate())

  return useQuery(
    getCustomer,
    {},
    {
      refetchOnMount: false,
      enabled: authenticated,
      transport: authTransport,
      throwOnError: false,
      select: data => data.customer,
    },
  )
}

export function useCustomerLocale() {
  const language = useGetCustomer()?.data?.language
  return language ? languageToLocale[language] : undefined
}
